// extracted by extract-css-chunks-webpack-plugin
module.exports = {"button_panel":"role-create__button_panel--3io0A","buttonPanel":"role-create__button_panel--3io0A"};